// Imperatywne potwierdzenie usunięcia: `if (!await confirm({ … })) return;`.
// Jeden wspólny stan i jeden modal (components/v2/confirm-host.vue, zamontowany
// w app.vue) — handler nie musi trzymać własnego `show` ani renderować dialogu.
// Zasada aplikacji: każde usunięcie zapisanych danych pyta „czy na pewno".
import { ref } from 'vue';

// Otwarte pytanie: { title, subject, message, confirmLabel } albo null.
const state = ref(null);
let resolver = null;

const settle = (ok) => {
    const resolve = resolver;
    resolver = null;
    state.value = null;
    resolve?.(ok);
};

// Zwraca Promise<boolean>: true = użytkownik potwierdził.
// Nowe pytanie, gdy poprzednie wisi, zamyka poprzednie jako „Anuluj".
export const askConfirm = ({ title = null, subject = null, message = null, confirmLabel = null } = {}) => {
    if (resolver) settle(false);
    state.value = { title, subject, message, confirmLabel };
    return new Promise((resolve) => { resolver = resolve; });
};

// Dla komponentu-gospodarza.
export const confirmState = state;
export const settleConfirm = settle;

export function useConfirm() {
    return { confirm: askConfirm };
}
